import { numericFormatter } from 'react-number-format';

import { Box, Text } from '@opendoor/bricks-next';

import { SelectQuestion } from 'src/lib/flow/FlowQuestion';
import { AnswerSet } from 'src/store/sellerFlow/AnswerSet';

type DetailReviewElementProps = {
  answer: AnswerSet[string] | undefined;
  props: {
    label?: string;
    helperText?: string;
    suffix?: string;
    options?: SelectQuestion['options'];
    showCommas?: boolean;
  };
};

const DetailReviewElement: React.FC<DetailReviewElementProps> = ({ answer, props }) => {
  const { label, helperText, suffix, options, showCommas } = props;

  let displayAnswer = typeof answer == 'undefined' ? 'N/A' : `${answer}`;
  if (options) {
    const opt = options.find((option) => option.value === answer);
    if (opt) {
      displayAnswer = opt.label;
    }
  }

  if (showCommas) {
    displayAnswer = numericFormatter(displayAnswer, { thousandSeparator: ',' });
    if (displayAnswer == 'N/A') {
      displayAnswer = '0';
    }
  }

  return (
    <Box
      borderBottomWidth="$default"
      paddingBottom="$12x"
      borderColor="$backgroundSecondary"
      className="detail-review"
      style={{ marginTop: '-24px' }}
    >
      <Box gap="$10x" flexDirection="row" justifyContent="space-between">
        <Text
          tag="label"
          typography="$bodyXlarge"
          $smallerThanLG={{
            typography: '$bodyLarge',
            fontWeight: '500',
          }}
          fontWeight="500"
        >
          {label}
        </Text>
        <Text tag="span" typography="$bodyXlarge" $smallerThanLG={{ typography: '$bodyLarge' }}>
          {displayAnswer}
          {suffix}
        </Text>
      </Box>
      <Text tag="p" color="$contentTertiary" typography="$bodySmall">
        {helperText}
      </Text>
    </Box>
  );
};

export default DetailReviewElement;
